var React = require('react');

function FilledHeart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.4134 1.76153C17.3781 0.625613 15.9575 0 14.413 0C13.2585 0 12.2012 0.369224 11.2704 1.09733C10.8008 1.46486 10.3752 1.9145 10 2.43932C9.62494 1.91466 9.19922 1.46486 8.7294 1.09733C7.79877 0.369224 6.74149 0 5.58701 0C4.04251 0 2.62177 0.625613 1.58646 1.76153C0.563507 2.88418 0 4.41788 0 6.08032C0 7.79138 0.630341 9.35765 1.98364 11.0096C3.19427 12.4873 4.93423 13.9873 6.94916 15.7243C7.63718 16.3175 8.41705 16.9899 9.22684 17.7061C9.44077 17.8957 9.71527 18 10 18C10.2846 18 10.5592 17.8957 10.7729 17.7064C11.5826 16.99 12.363 16.3173 13.0513 15.7238C15.0659 13.9872 16.8059 12.4873 18.0165 11.0094C19.3698 9.35765 20 7.79138 20 6.08016C20 4.41788 19.4365 2.88418 18.4134 1.76153Z","fill":"#EA5265"}));
}

FilledHeart.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = FilledHeart;

FilledHeart.default = FilledHeart;
